module.exports = __webpack_public_path__ + "h5/img/master_6.1232d7cf.jpg";